type ErrorCause = {
  code: string
  message?: string
  [key: string]: unknown
}

export type { ErrorCause }
